<script setup>
    const props = defineProps({
        name: {
            type: [String],
        }
    });
</script>

<template>
    <svg>
        <use :xlink:href="`#acc-${props.name}`"></use>
    </svg>
</template>